import { Card, Theme } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { makeStyles } from '@mui/styles';
import AgentSummary from './AgentSummary';
import LocationMap from './LocationMap';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { getSubmissionDetails, getSubmissionDetailsLoading, getSubmissionProducer } from 'application/redux/selectors';
import { useActions } from 'hooks/useActions';
import { clearSelectedSubmission, fetchOneSubmission } from 'application/redux/actions';
import LumenLoader from 'components/Loader';
import { getAssignedProducer } from 'application/redux/selectors/submissionUserPreferences';
import PremiumChart from './PremiumChart';
import LocationsChart from './LocationsChart';
import MonthlySummary from './MonthlySummary';
import RenewalsChart from './RenewalsChart';
import { useEffect } from 'react';
import { useEdisonDock } from 'hooks/EdisonChatDock';
import { ProducerDashboardProps } from 'components/LrProducerDashboard/index';

const useStyles = makeStyles((theme: Theme) => ({
    expandedMap: {
        backgroundColor: theme.palette.background.paper,
        height: '99%',
        position: 'absolute',
        left: '5px',
        zIndex: 1,
        padding: '10px',
        borderRadius: '8px',
        top: '5px',
        width: '99%',
    },
}));

const BRLrProducerDashboard: React.FunctionComponent<ProducerDashboardProps> = (props) => {
    // this is a submission_id from which to load the dashboard
    const { submissionId, producer, productLineCode } = { ...props };

    const isLoading = useSelector(getSubmissionDetailsLoading);
    const submission = useSelector(getSubmissionDetails);
    const submissionProducer = useSelector(getSubmissionProducer);
    const assignedProducer = useSelector(getAssignedProducer);
    const { clearSubmission, fetchSubmission } = useActions({
        clearSubmission: clearSelectedSubmission,
        fetchSubmission: fetchOneSubmission,
    });

    const reload = () => {
        if (submissionId && submissionId !== submission.id && !isLoading) {
            clearSubmission();
            fetchSubmission(submissionId);
        }
    };
    const classes = useStyles();
    React.useEffect(reload, [submissionId]);

    const { setHidden: setEdisonHidden } = useEdisonDock();

    useEffect(() => {
        setEdisonHidden(true);
        return () => setEdisonHidden(false);
    }, []);

    if (submissionId && submissionId !== submission.id) return <LumenLoader />;

    // if we are passed in an ID use that first, otherwise use a submission producer if that is passed in, default to using the system assignedProducer
    const contextProducer = producer
        ? producer.id !== '0'
            ? producer
            : undefined
        : submissionProducer && submissionProducer.id
        ? submissionProducer
        : assignedProducer;

    return (
        <Grid container spacing={0} style={{ height: '92vh', minHeight: '850px', position: 'relative' }}>
            <Grid
                container
                spacing={0}
                direction={'column'}
                justifyContent={'space-between'}
                sm={3}
                xs={12}
                style={{ height: '100%', padding: '5px' }}
            >
                <Grid style={{ flex: 2, paddingBottom: '5px' }}>
                    <Card style={{ height: '100%' }}>
                        <AgentSummary producerId={contextProducer?.id} productLineCode={productLineCode} />
                    </Card>
                </Grid>
                {/*<Grid style={{ flex: 3, paddingTop: '5px', overflow: 'auto' }}>*/}
                {/*    <Card style={{ height: '100%' }}>*/}
                {/*        <MonthlySummary productLineCode={productLineCode} />*/}
                {/*    </Card>*/}
                {/*</Grid>*/}
            </Grid>
            <Grid sm={9} xs={12} style={{ padding: '5px', height: '100%' }}>
                <Card style={{ height: '100%' }}>
                    <div style={{ height: '60%' }}>
                        <LocationMap
                            producerId={contextProducer?.id}
                            expandStyleClass={classes.expandedMap}
                            productLineCode={productLineCode}
                            expanded
                        />
                    </div>
                    {/*<Grid*/}
                    {/*    container*/}
                    {/*    style={{*/}
                    {/*        padding: '10px',*/}
                    {/*        height: '40%',*/}
                    {/*    }}*/}
                    {/*    justifyContent={'center'}*/}
                    {/*    alignItems={'center'}*/}
                    {/*>*/}
                    {/*    <Grid xs={3} style={{ height: '100%' }}>*/}
                    {/*        <RenewalsChart productLineCode={productLineCode} />*/}
                    {/*    </Grid>*/}
                    {/*    <Grid xs={3} style={{ height: '100%' }}>*/}
                    {/*        <LocationsChart productLineCode={productLineCode} />*/}
                    {/*    </Grid>*/}
                    {/*    <Grid xs={6} style={{ height: '100%' }}>*/}
                    {/*        <PremiumChart productLineCode={productLineCode} />*/}
                    {/*    </Grid>*/}
                    {/*</Grid>*/}
                </Card>
            </Grid>
        </Grid>
    );
};

export default BRLrProducerDashboard;
